import * as React from 'react'
import { connect } from 'react-redux'
import { RootState, Dispatch } from '-/store'
import Loading from '-/components/basic/Loading/Loading'

const { memo, Fragment } = React

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const mapState = (state: RootState) => ({
  currentAccount: state.account.current,
  loading: state.loading.effects.account.getAccountInfo,
})

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatch = (dispatch: Dispatch) => ({
  getAccountInfo: dispatch.account.getAccountInfo,
})

type Props = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> & {
    children: JSX.Element
  }

// 是否初始渲染
let isInitRender = true
// 是否初始加载(避免其他地方调用getAccountInfo引起阻塞渲染)
let isInitLoading = true

const UpdateUserInfo = memo((props: Props) => {
  const { currentAccount, getAccountInfo, loading, children } = props
  // 仅执行一次
  if (currentAccount && isInitRender) {
    isInitRender = false
    getAccountInfo().then(() => {
      isInitLoading = false
    })
  }
  return loading && isInitLoading ? <Loading /> : <Fragment>{children}</Fragment>
})

export default (connect(
  mapState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapDispatch as any
)(UpdateUserInfo) as unknown) as React.ComponentType
